import { Link } from "react-router-dom";
import { Leaf, Target, Heart, Truck } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function About() {
  return (
    <div>
      <section className="bg-slate-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 py-20">
          <span className="text-xs font-semibold uppercase tracking-wider text-yellow-400">Our Story</span>
          <h1 className="font-heading text-4xl lg:text-5xl font-extrabold mt-2 max-w-2xl">Bringing fresh, affordable groceries to every Indian neighbourhood.</h1>
          <p className="mt-4 text-slate-300 text-lg max-w-2xl">D K BAZAAR started with a single store and a simple belief — quality groceries should be close, fair, and fresh. Today we're a growing multi-store franchise network across the country.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-8 py-16 grid md:grid-cols-4 gap-6">
        {[[Leaf, "Freshness First", "Farm-to-shelf sourcing with strict quality checks."],
          [Target, "Fair Pricing", "Everyday value through an efficient central supply chain."],
          [Heart, "Community Rooted", "Locally owned franchises that serve their neighbourhoods."],
          [Truck, "Reliable Supply", "A logistics backbone that keeps shelves stocked."]].map(([Icon, t, d], i) => (
          <div key={i} className="rounded-2xl border border-slate-200/80 dark:border-slate-800 p-6 bg-white dark:bg-slate-900">
            <span className="grid place-items-center w-12 h-12 rounded-xl bg-yellow-100 dark:bg-yellow-950 text-yellow-600"><Icon className="w-6 h-6" /></span>
            <h3 className="font-heading font-semibold text-lg mt-4">{t}</h3>
            <p className="text-sm text-muted-foreground mt-1">{d}</p>
          </div>
        ))}
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-8 pb-16">
        <div className="grid sm:grid-cols-4 gap-6 rounded-3xl bg-yellow-400 text-slate-900 p-10 text-center">
          {[["40+", "Stores"], ["12", "States"], ["500+", "Team members"], ["1M+", "Happy customers"]].map(([n, l], i) => (
            <div key={i}><p className="font-heading font-extrabold text-4xl">{n}</p><p className="text-slate-700 mt-1">{l}</p></div>
          ))}
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-4 text-center pb-20">
        <h2 className="font-heading text-3xl font-bold">Want to grow with us?</h2>
        <p className="text-muted-foreground mt-2">Explore franchise opportunities and open careers.</p>
        <div className="mt-6 flex gap-3 justify-center">
          <Button asChild className="bg-yellow-400 hover:bg-yellow-500 text-slate-900"><Link to="/franchise">Franchise</Link></Button>
          <Button asChild variant="outline"><Link to="/careers">Careers</Link></Button>
        </div>
      </section>
    </div>
  );
}
